// extracted by mini-css-extract-plugin
export default {"container":"TagForm_container__wDzXF","label":"TagForm_label__gdJb2","error":"TagForm_error__oN5U+","separator":"TagForm_separator__Y+R+t","btns":"TagForm_btns__APCTi"};